import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import BvUnstyledBtn, { type BvUnstyledBtnSignature } from 'volta/components/bv-unstyled-btn';
import BvIcon from 'volta/components/bv-icon';
import BvPopover from 'volta/components/bv-popover';
import BvMenu from 'volta/components/bv-menu';
import sortableHandle from 'ember-sortable/modifiers/sortable-handle';
import Component from '@glimmer/component';
import { array } from '@ember/helper';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import cssVars from 'volta/modifiers/css-vars';
import { fn } from '@ember/helper';
import type { TOC } from '@ember/component/template-only';
import type { THueVariationString } from 'volta/utils/style-utils';
import orElse from 'volta/helpers/or-else';
interface BtnSignature {
    Args: {
        disabled?: boolean;
        color?: THueVariationString;
        onClick?: (event: PointerEvent) => void;
    };
    Element: HTMLButtonElement;
}
const Btn: TOC<BtnSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvUnstyledBtn
    @onClick={{@onClick}}
    disabled={{@disabled}}
    class='bv-dnd-handle'
    ...attributes
    {{sortableHandle}}
  >
    <BvIcon
      class='bv-dnd-handle__icon'
      @glyph='handler'
      @size='sm'
      @color={{if @disabled 'icon-disabled' (orElse @color 'icon')}}
    />
  </BvUnstyledBtn>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export interface BvDndHandleSignature {
    Args: {
        disabled?: boolean;
        direction?: 'x' | 'y' | 'grid';
        color?: THueVariationString;
        onMoveNext?: () => void;
        onMovePrevious?: () => void;
    };
    Blocks: {
        default: [];
    };
    Element: BvUnstyledBtnSignature['Element'];
}
export default class BvDndHandle extends Component<BvDndHandleSignature> {
    get direction() {
        return this.args.direction ?? 'y';
    }
    get cursor() {
        return this.direction === 'x' ? 'ew-resize' : 'ns-resize';
    }
    get shouldDisplayMenu() {
        return ((this.args.onMoveNext != null || this.args.onMovePrevious != null) && this.direction != 'grid' && !this.args.disabled);
    }
    get nextLabel() {
        return this.direction === 'x' ? 'moveRight' : 'moveDown';
    }
    get nextIcon() {
        return this.direction === 'x' ? 'chevron-right' : 'chevron-down';
    }
    get previousIcon() {
        return this.direction === 'x' ? 'chevron-left' : 'chevron-up';
    }
    get previousLabel() {
        return this.direction === 'x' ? 'moveLeft' : 'moveUp';
    }
    onTogglePopover = (toggle: () => void, event: PointerEvent)=>{
        event.stopPropagation();
        toggle();
    };
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{#if this.shouldDisplayMenu}}
      <BvPopover as |popover|>
        <Btn
          @disabled={{@disabled}}
          @color={{@color}}
          @onClick={{fn this.onTogglePopover popover.toggle}}
          {{cssVars cursor=this.cursor}}
          {{popover.trigger}}
          ...attributes
        />
        <popover.Content>
          <BvMenu
            @onAnyItemAction={{popover.close}}
            @sections={{array
              (hash
                items=(array
                  (if
                    @onMoveNext
                    (hash content=(t this.nextLabel) onClick=@onMoveNext icon=this.nextIcon)
                  )
                  (if
                    @onMovePrevious
                    (hash
                      content=(t this.previousLabel) onClick=@onMovePrevious icon=this.previousIcon
                    )
                  )
                )
              )
            }}
          />
        </popover.Content>
      </BvPopover>
    {{else}}
      <Btn @disabled={{@disabled}} @color={{@color}} {{cssVars cursor=this.cursor}} ...attributes />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvDnd::Handle': typeof BvDndHandle;
        'bv-dnd/handle': typeof BvDndHandle;
    }
}
